import React from "react";
import { Body } from "../UIKits/Typography/Typography";
import Button from "../UIKits/Button/Button";
import { PaymentStatusCard, PaymentStatusCardProps } from "../BuyPowerWorkFlow/PaymentStatusCard";
import { useFundWalletStore } from "../../store/fundWallet";

const FundWalletSuccessStep: React.FC<Omit<PaymentStatusCardProps, "status" | "children">> = (props) => {
  const { paymentResult, resetFlow } = useFundWalletStore();

  const handleClose = () => {
    resetFlow();
    props.onClose();
  };

  return (
    <PaymentStatusCard {...props} status="success">
      <div className="  w-[60%] mt-4 mb-6">
        <Body color="secondary" className="!text-center">
          Your have successfully funded your account with
          <span className="font-medium ml-1 text-foreground">{paymentResult?.amount}</span>
        </Body>
      </div>

      {/* Action Buttons */}
      <div className="w-[40%] mt-6 flex gap-3 justify-center">
        <Button size="sm" className="w-full" onClick={handleClose}>
          Done
        </Button>
      </div>
    </PaymentStatusCard>
  );
};

export default FundWalletSuccessStep;
